import { useContext, useEffect, useState } from "react";
import { ControlContext } from "../../ControlContext.jsx";

export default function Glass({ glassDepth }) {
  const {
    printWidth,
    printHeight,
    borderWidth,
    borderHeight,
    glassThickness,
    frameType,
    perspexType,
    glassType,
  } = useContext(ControlContext);

  const [glassWidth, setGlassWidth] = useState(0);
  const [glassHeight, setGlassHeight] = useState(0);

  const [glassOverflow, setGlassOverflow] = useState(0);

  const [roughness, setRoughness] = useState(0.0);
  const [opacity, setOpacity] = useState(0.6);
  const [iridescence, setIridescence] = useState(1.0);
  const [reflectivity, setReflectivity] = useState(1.0);

  useEffect(() => {
    switch (glassType) {
      case "Gloss":
        setRoughness(0.0);
        setOpacity(0.3);
        setIridescence(0);
        setReflectivity(2);
        break;
      case "Matt":
        setRoughness(0.1);
        setOpacity(0.6);
        setIridescence(0);
        setReflectivity(1);
        break;
      case "TruLife":
        setRoughness(0.0);
        setOpacity(0.4);
        setIridescence(1);
        setReflectivity(0.7);
        break;
    }
  }, [glassType]);

  useEffect(() => {
    switch (frameType) {
      case "Box":
        setGlassOverflow(0.8);
        break;
      default:
        setGlassOverflow(0);
        break;
    }
  }, [frameType]);

  useEffect(() => {
    setGlassWidth(glassOverflow + printWidth + 2 * borderWidth);
    setGlassHeight(glassOverflow + printHeight + 2 * borderHeight);
  }, [printWidth, printHeight, borderWidth, borderHeight, frameType]);

  return (
    <>
      <mesh position-z={glassDepth}>
        <boxGeometry args={[glassWidth, glassHeight, glassThickness]} />
        <meshPhysicalMaterial
          // refractiveIndex={1.1}

          // color={"white"}
          // metalness={1}
          roughness={roughness}
          opacity={opacity}
          transparent={true}
          transmission={1}
          ior={1.5}
          // thickness={0.0} 
          // clearcoat={1.0}
          // clearcoatRoughness={0.1}
          iridescence={iridescence}
          // iridescenceIOR={0}
          reflectivity={reflectivity}
          envMapIntensity={1}
        />
      </mesh>
    </>
  );
}
